// extracted by mini-css-extract-plugin
export default {"base":"vp_yQoE4","image":"vp_ZAjlK","alignCenter":"vp_xoflv","tools":"vp_qd1Ex","label":"vp_qQUsw","visible":"vp_XRdIj","scaleButton":"vp_URCWn","line":"vp_pGLyV"};